var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLineArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6834 0.483466C10.9713 0.173887 11.3614 -4.65028e-07 11.7682 -4.47248e-07C12.1749 -4.29467e-07 12.5651 0.173887 12.8529 0.483467L21.5511 9.85127C21.8385 10.1612 22 10.5814 22 11.0195C22 11.4576 21.8385 11.8777 21.5511 12.1877L12.8529 21.5555C12.562 21.8479 12.177 22.0072 11.7791 21.9998C11.3813 21.9923 11.0017 21.8188 10.7203 21.5158C10.4389 21.2128 10.2778 20.8039 10.271 20.3755C10.2641 19.947 10.412 19.5324 10.6834 19.2191L16.762 12.6726L1.53498 12.6726C1.12788 12.6726 0.737449 12.4985 0.449585 12.1884C0.16172 11.8784 -7.76922e-07 11.4579 -7.57757e-07 11.0195C-7.38592e-07 10.581 0.16172 10.1606 0.449585 9.85054C0.737449 9.54052 1.12788 9.36635 1.53498 9.36635L16.762 9.36635L10.6834 2.81991C10.396 2.50994 10.2345 2.08977 10.2345 1.65169C10.2345 1.2136 10.396 0.793431 10.6834 0.483466Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLineArrowRight);
export default __webpack_public_path__ + "static/media/icon-line-arrow-right.2db81b0ca8fab8ea55c5dc898cc31f59.svg";
export { ForwardRef as ReactComponent };